import clamp from 'lodash/clamp';
import type { AppState, Payload } from 'store/state';

export function LoadingAction(state: AppState, payload: Payload): AppState {
	const loading = payload?.loading?.loading || 0;
	return {
		...state,
		loading: {
			...state.loading,
			...payload?.loading,
			loading: clamp(state.loading.loading + loading, 0, Number.MAX_SAFE_INTEGER)
		}
	};
}
